import { useQuery, gql, type QueryResult, QueryHookOptions } from '@apollo/react-hooks';
import { getTenant } from '#/graphql/queries';
import type { GetTenantQuery } from '#/graphql/types';
import _ from 'lodash';

export const GET_TENANT = gql(getTenant);

const useTenantQuery = (id?: string, options?: QueryHookOptions) => {
  const query: QueryResult<GetTenantQuery> = useQuery(
    GET_TENANT,
    _.merge({ variables: { id } }, options || {}),
  );

  return query;
};

export default useTenantQuery;
